export default __webpack_public_path__ + "static/media/klinton.e4aad990.jpg";